import CodeMirror from 'codemirror';
import { createSpanReplacementNode, createWarningSpanReplacementNode } from '../markers/utils';
import { hasTokenIncludes } from '../utils/codemirror';
import { IPlaceholder } from '../index.d';


export function replacePlacehoder(
  editor: CodeMirror.Editor,
  tokens: CodeMirror.Token[],
  idx: number) {
  const token = tokens[idx];
  if (hasTokenIncludes(token, ['placeholder'])) {
    const line = token.state.line;
    const placeholder = token.state.placeholder as IPlaceholder;

    const startPos = { line, ch: token.start };
    const endPos = { line, ch: token.end };

    const classname = placeholder.classname || 'cm-placeholder';

    const replacedNode = placeholder.isWarning ?
      createWarningSpanReplacementNode(
        placeholder.name,
        classname,
        placeholder.description
      ) :
      createSpanReplacementNode(
        placeholder.name,
        classname,
        placeholder.description
      );

    if (placeholder.oninit) {
      (replacedNode as any).removeMarkerListener = placeholder.oninit({
        token,
        editor,
        target: replacedNode,
        position: { start: startPos, end: endPos }
      });
    }

    editor.getDoc().markText(startPos, endPos, {
      replacedWith: replacedNode
    });
    return 1;
  }


  return 0;
}
